import { notFound, redirect } from "@tanstack/react-router";
import legalStyles from "../styles/legal.css?url";
import { platformPageHead, platformShellFrom } from "../platform/head";
import { loadPolicyPage } from "../platform/legal";
import { documentHead } from "./document-route";
import { withStylesheet } from "./head";

// /privacy and /terms: their loader and head, in the site's first bundle with every route's, so
// this module imports no components (components/policy-page.tsx draws the page).

export type PolicyData = Exclude<
  Awaited<ReturnType<typeof loadPolicyPage>>,
  { kind: "missing" | "redirect" }
>;

/** A policy page's data; a creator's redirect is followed and a missing page is a 404. */
export async function loadPolicy(path: "/privacy" | "/terms") {
  const data = await loadPolicyPage({ data: path });
  if (data.kind === "redirect") throw redirect({ href: data.to, statusCode: 302 });
  if (data.kind === "missing") throw notFound();
  return data as PolicyData;
}

export function policyHead(
  matches: readonly { loaderData?: unknown; routeId: string }[],
  data: PolicyData | undefined,
  pathname: string,
) {
  if (data?.kind === "legal")
    return withStylesheet(
      platformPageHead(platformShellFrom(matches), {
        pathname,
        title: `${data.title} | Drate`,
        description: data.description,
        canonicalPath: data.path,
      }),
      legalStyles,
    );
  return documentHead(matches, data, pathname, {
    title: (shell) => `Page not found | ${shell.creator.name}`,
    description: () => "This page could not be found.",
  });
}
